import React from "react";
import {
  Box,
  CarSideIcon,
  ChartPieIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  Cog8ToothIcon,
  GlobeAltIcon,
  MegaphoneIcon,
  PhoneIcon,
  TagIcon,
  UserIcon,
  UsersIcon
} from "@dealer-center/core-components";
import { ICON_BOX_STYLES } from "../styleConstants";

// Map Material Icon names to Interstate icon components
const ICON_MAP: Record<string, React.ComponentType<any>> = {
  textsms: ChatBubbleLeftRightIcon,
  phonelink: GlobeAltIcon,
  directions_car: CarSideIcon,
  contact_mail: UsersIcon,
  settings_applications: Cog8ToothIcon,
  car_tag: TagIcon,
  photo_size_select_large: MegaphoneIcon,
  timeline: ChartPieIcon,
  phone: PhoneIcon,
  headphones: UserIcon,
  schedule: ClockIcon
};

interface CardIconProps {
  iconKey: string;
  iconColor: string;
  title?: string;
  iconSize?: string;
}

export const CardIcon: React.FC<CardIconProps> = ({
  iconKey,
  iconColor,
  title,
  iconSize = "20px"
}) => {
  const IconComponent = ICON_MAP[iconKey];

  if (!IconComponent) {
    return null;
  }

  return (
    <Box
      className="application-icon"
      sx={{
        ...ICON_BOX_STYLES.base,
        backgroundColor: iconColor,
        pointerEvents: "none",
        "& svg": { color: "white !important" },
        "& svg path": { fill: "white !important" },
        "& svg circle": { fill: "white !important" },
        "& svg rect": { fill: "white !important" }
      }}
    >
      <IconComponent
        style={{
          fontSize: iconSize,
          lineHeight: "30px",
          color: "white"
        }}
        title={title}
      />
    </Box>
  );
};
